<p-tabView>
  <p-tabPanel header="Orgão Justiça">
    <div class="p-fluid">
      <div class="p-field p-grid">
        <label for="id" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Id:</label>
        <div class="p-col-12 p-md-10">
          <input pInputText type="text" name="id" readonly [ngModel]="entidade.id" />
        </div>
      </div>

      <div class="p-field p-grid">
        <label for="nome" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Nome:</label>
        <div class="p-col-12 p-md-10">
          <input pInputText type="text" name="nome" [(ngModel)]="entidade.nome" />
        </div>
      </div>

      <div class="p-field p-grid">
        <label for="sigla" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Sigla:</label>
        <div class="p-col-12 p-md-10">
          <input pInputText type="text" name="sigla" [(ngModel)]="entidade.sigla" />
        </div>
      </div>

      <div class="p-field p-grid">
        <label for="identificador" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Numeração única identificador::</label>
        <div class="p-col-12 p-md-10">
          <input pInputText type="number" name="identificador" [(ngModel)]="entidade.numeracaoUnicaIdentificador" />
        </div>
      </div>

      <div class="p-field p-grid">
        <label for="segmento-justica" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Segmento Justiça:</label>
        <div class="p-col-12 p-md-10">
          <p-dropdown
            placeholder="Favor selecionar a unidade de justiça desejada"
            [options]="segmentoItens"
            filter="true"
            [(ngModel)]="entidade.segmento">
          </p-dropdown>
        </div>
      </div>
    </div>
  </p-tabPanel>

  <p-tabPanel header="Auditoria" [disabled]="entidade.id === undefined">
    <div class="p-fluid">
      <div class="p-field p-grid">
        <label for="isercao-data" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold"> Inserção - Data:</label>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaDataInsercao | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
      </div>
      <div class="p-field p-grid">
        <label for="isercao-usuario" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Inserção - Usuário:</label>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaUsuarioInsercao?.nome}}</div>
      </div>
      <div class="p-field p-grid">
        <label for="ultima-alteracao-data" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Última alteração -
          Data:</label>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaData | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
      </div>
      <div class="p-field p-grid">
        <label for="ultima-alteracao-usuario" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Última alteração -
          Usuário:</label>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaUsuario?.nome}}</div>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>
